/**
 * publicRoutes.ts — percorsi dell'app leggibili anche senza login.
 *
 * PERCHÉ ESISTE (Ott 2026): Search Console segnalava /events come «Pagina con
 * reindirizzamento» perché la rotta era protetta: un crawler senza sessione
 * veniva mandato su /login. La pagina eventi pubblici deve invece essere
 * leggibile da chiunque, mantenendo l'esperienza completa per chi è loggato.
 *
 * Regola: aggiungere qui SOLO pagine che mostrano esclusivamente dati
 * pubblici. Le aree personali (dashboard, garage, locale, dealer, admin)
 * restano protette.
 */

export const PUBLIC_APP_PATHS: readonly string[] = ["/events"];

/** true se `pathname` (senza query) è una pagina pubblica dell'app. */
export function isPublicAppPath(pathname: string): boolean {
  const clean = `/${(pathname || "")
    .split("?")[0]
    .replace(/^\/+|\/+$/g, "")}`;
  return PUBLIC_APP_PATHS.includes(clean);
}
